import { render, staticRenderFns } from "./CandidateList.vue?vue&type=template&id=b1a23382&scoped=true&"
import script from "./CandidateList.vue?vue&type=script&lang=js&"
export * from "./CandidateList.vue?vue&type=script&lang=js&"
import style0 from "./CandidateList.vue?vue&type=style&index=0&id=b1a23382&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a23382",
  null
  
)

export default component.exports